import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { CommonService } from 'src/app/core/services/common.service';
import { Router } from '@angular/router';
import { Message } from 'src/app/core/class/message';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent extends BaseComponent implements OnInit {

  constructor(
    private router: Router,
    private translate: TranslateService,
    public commonService: CommonService,
    public message: Message,
  ) {
    super(commonService, message);
  }

  ngOnInit() {
  }

  /**
   * <pre>
   * <b>Method name: onChangeLanguage</b>
   * <b>Explanation: </b> Method setting change langauge
   * </pre>
   * @author GCS 2019/08/26 by phuongtq
   *
   */
  onChangeLanguage(languageSelected: string) {
    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }

  login() {
    this.router.navigate(['enterprise-login']);
  }
}
